import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import StatCard from '../../components/user-management/StatCard';
import UserBotList from '../../components/user-management/UserBotList';
import { useSelector } from 'react-redux';
import SearchFilter from '../../components/analytics-and-insights/SearchFilter';
import { fetchUsersData } from '../../api/user';
import useLoader from '../../hooks/useLoader';
import Loader from '../../components/common/Loader/Loader';
import Tooltip from '@mui/material/Tooltip';
const Dashboard = () => {
  const [data, setData] = useState([]);
  const { filter } = useSelector((state) => state);
  const { loading, startLoading, stopLoading } = useLoader();

  // const fetchData = async () => {
  //   try {
  //     startLoading();
  //     await fetchUsersData(filter, userCardData, setData);
  //     stopLoading();
  //   } catch (err) {
  //     console.error('Error while loading user data', err);
  //   }
  // };

  // useEffect(() => {
  //   fetchData();
  // }, [filter]);

  // Calculate total value and percentages for each item
  // const updatedData = data.map((item) => {
  //   if (item.maleCount !== undefined && item.femaleCount !== undefined) {
  //     // Calculate percentage for male and female if counts exist
  //     const totalCount = item.maleCount + item.femaleCount;
  //     const malePercentage =
  //       ((item.maleCount / totalCount) * 100).toFixed(2) + '%';
  //     const femalePercentage =
  //       ((item.femaleCount / totalCount) * 100).toFixed(2) + '%';

  //     return {
  //       ...item,
  //       value: totalCount.toLocaleString(), // Show total number in 'value'
  //       male: malePercentage,
  //       female: femalePercentage,
  //     };
  //   } else {
  //     // If 'value' is already set for this item, just return it as is
  //     return item;
  //   }
  // });

  return (
    <div>
      <div className="d-flex gap-16 align-items-center">
        <span>
          <img
            src="/assets/images/admin-panel/technical-support.png"
            className="img-fluid"
            alt=""
          />
        </span>
        <div className="">
          <div className="d-flex gap-10 text-black align-items-center fw-bold font-p font-36">
             {/* <Tooltip title="Go Back" arrow placement="top">
                 <Link
                   to="/"
                   className="w-32-px h-32-px radius-8 object-fit-cover d-flex justify-content-center align-items-center fw-semibold text-xs bg-neutral-900 text-white"
                 >
                   <iconify-icon icon="line-md:arrow-small-left" width="24" height="24"></iconify-icon>
                 </Link>
               </Tooltip> */}
            Bot Users Management
          </div>
          <p>Manage and empower users for a premium dating experience.</p>
        </div>
      </div>
      {/* 
      <div className="d-flex gap-2 justify-content-between align-items-center py-16">
        <div className="">
          <span class="badge text-md fw-medium bg-warning-900 px-20 py-9 radius-8 text-white">
            Overall
          </span>
        </div>

        <div className="d-flex gap-2 justify-content-between align-items-center">
          <div className="bg-light-100 d-flex align-items-center gap-3 pe-20 radius-6">
            <CountrySelect /> <FilterState />
          </div>
          <BasicRangeShortcuts id="range1" />
          <button class="badge text-sm fw-medium bg-light-100 px-20 py-12 radius-6 text-secondary-light">
            Male
          </button>
          <button class="badge text-sm fw-medium bg-light-100 px-20 py-12 radius-6 text-secondary-light">
            Female
          </button>
          <button class="badge text-sm fw-medium border border bg-transparent px-20 py-12 radius-6 text-secondary-light">
            Reset
          </button>
        </div>
      </div> */}

      <SearchFilter isHideUserManagement={false} isHideSelectCam={false}  />

      {/* {loading ? (
        <Loader />
      ) : (
        <div className="gap-16 updatedData">
          {updatedData.map((item, index) => (
            <StatCard key={index} data={item} />
          ))}
        </div>
      )} */}

      <div className="mt-32">
        <UserBotList />
      </div>
    </div>
  );
};

export default Dashboard;
